const CleanerActivity = () => import('../components/CleanerActivity.vue');

export const cleanerActivityRoutes = [
    {
        path: '/cleaner-activity',
        name: 'cleanerActivity',
        component: CleanerActivity,
    },
];
